import { targetsService } from "@/_services";
import "./coldCall.css";

// Estado compartido por las dos modales de llamada (Opportunity.vue y
// BdrTasks.vue): los 7 campos del order que el booker ve tal cual.
export const COLD_CALL_OBJECTION_OFFSET = 100;

export const coldCallScriptMixin = {
  data() {
    return {
      coldCall: null,
      coldCallTargetId: null,
    };
  },
  computed: {
    ccObjections() {
      return (this.coldCall && this.coldCall.cc_objections) || [];
    },
    ccSelectedObjection() {
      const i = this.answersIndex - COLD_CALL_OBJECTION_OFFSET;
      return i >= 0 ? this.ccObjections[i] || null : null;
    },
    ccPitch() {
      return (this.coldCall && this.coldCall.cc_pitch) || "";
    },
  },
  watch: {
    // Al cambiar de pestana a la izquierda, volver arriba del texto.
    answersIndex() {
      const el = this.$refs.ccScriptCard;
      if (el) {
        el.scrollTop = 0;
      }
    },
  },
  methods: {
    // Secours: si el Main Script no esta (vacio o error) y el AM escribio un
    // Pitch, se muestra el Pitch tal cual. El booker nunca ve la columna vacia.
    ccShowPitchFallback(result) {
      return (
        this.answersIndex == 99 &&
        !!this.ccPitch &&
        (!result || ["EMPTY", "No response generated", "S"].includes(result))
      );
    },
    loadColdCallScript(targetId) {
      if (!targetId) {
        this.coldCall = null;
        this.coldCallTargetId = null;
        return;
      }
      if (targetId === this.coldCallTargetId && this.coldCall) {
        return;
      }
      this.coldCall = null;
      this.coldCallTargetId = targetId;
      targetsService
        .getColdCallScript(targetId)
        .then((data) => {
          // Si mientras tanto se abrio otro order, descartar la respuesta vieja.
          if (this.coldCallTargetId === targetId) {
            this.coldCall = data;
          }
        })
        .catch(() => {
          // Sin acceso o sin campos: la modal queda como siempre.
          if (this.coldCallTargetId === targetId) {
            this.coldCall = null;
          }
        });
    },
    ccObjectionIndex(i) {
      return COLD_CALL_OBJECTION_OFFSET + i;
    },
  },
};
